/**
 * 活动编排相关 API 类型
 * 对齐 IDL：
 * - commerce/api/activity_api.thrift · ResolveOffersV2（POST /commerce/activity/offersresolve/v2）
 */

import type { IActivityMetaDTO, IPayMethodDTO } from '@/apis/commerce';

// ─── ResolveOffers / ResolveOffersV2 ─────────────────────────────────────────

/** ResolveOffersRequest（v1/v2 共用请求体） */
export interface IResolveOffersParams {
    /** 场景标识：在哪里发生（如 paywall / home） */
    scene: string;
    /** 业务决策：query / activate（ACTIVATE 幂等且不重置倒计时） */
    action: string;
    /** 用户动作：open / exit / cold_start 等 */
    event: string;
    /** 触发的剧 ID */
    trigger_drama_id?: string;
    /** 推送事件 */
    push_event?: string;
    /** 未支付订单 ID */
    unpaid_order_id?: string;
}

/**
 * ActivityNoType（activity_api.thrift）
 * FirstChargePopup = 1 首冲弹窗；CancelRecallPopup = 2 取消自动订阅后弹窗
 */
export enum EActivityNoType {
    FirstChargePopup = 1,
    CancelRecallPopup = 2,
}

/** BenefitType（common.thrift） */
export enum EBenefitType {
    Recharge = 1,
    Subscribe = 2,
}

/** ActivityOfferItemDTO：充值类活动商品 */
export interface IActivityOfferItemDTO {
    product_id: string;
    third_product_id: string;
    benefit_type: EBenefitType;
    price_cents: number;
    currency_sign: string;
    currency: string;
    coins: number;
    vouchers: number;
    bonus: string;
    activity_info?: IActivityMetaDTO;
    methods?: IPayMethodDTO[];
}

/** ActivitySubscribeItemDTO：订阅类活动商品 */
export interface IActivitySubscribeItemDTO {
    product_id: string;
    third_product_id: string;
    name: string;
    discribtion?: string;
    tags?: string;
    period_sign?: string;
    price_cents: number;
    currency_sign: string;
    vip_date: string;
    currency: string;
    offering_strategy?: string;
    activity_info?: IActivityMetaDTO;
    old_product_id?: string;
    old_third_product_id?: string;
    methods?: IPayMethodDTO[];
}

/** ResolveOffersV2Data */
export interface IResolveOffersV2Data {
    hit: boolean;
    reason?: string;
    server_ts?: number;
    /** 活动列表（仅元信息） */
    activities?: IActivityMetaDTO[];
    /** 扁平充值商品，每项可带 activity_info */
    recharges?: IActivityOfferItemDTO[];
    /** 扁平订阅商品，每项可带 activity_info */
    subscribes?: IActivitySubscribeItemDTO[];
    /** v2 预览秒数；命中时必返 */
    preview_duration_sec?: number;
    paypal_support_currency?: string[];
    stripe_support_currency?: string[];
}

/** @deprecated 使用 IResolveOffersParams；保留别名避免旧引用断裂 */
export type TOfferResolveParams = IResolveOffersParams;
/** @deprecated 使用 IResolveOffersV2Data */
export type TOfferResolveResult = IResolveOffersV2Data;
